import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    simulationList: {},
  }
}

const state = getDefaultState()

const mutations = {
  SET_MENU_LISTS(state, payload) {
    state.simulationList = payload
  },
}

const actions = {
  async getSimulationLists({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation.list'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async checkSimulationResultStatuses({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation.result-status'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async storeSimulation({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation.store'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async editSimulation({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation.edit'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async updateSimulation({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation.update'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async duplicateSimulation({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation.duplicate'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async saveAsSimulation({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.save-as'), payload)
    return apiResult.data
  },
  async deleteSimulation({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.delete'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async execSimulation({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.execute'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async execAllSimulation({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.all-execute'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async executeForSelectedResults({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.execute-for-selected-results'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async executeForSelectedApplicationCandidates({ commit }, payload) {
    const apiResult = await apiService.post(
      route('member.fcs.simulation.execute-for-selected-application-candidates'),
      payload
    )
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  // 2024FCS
  async getRecord({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.record'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getSimulationPaginate({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.paginate'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async create({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.create'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async update({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.update'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getTotalProjectRegistrationArea({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.get_total_project_registration_area'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getProjectStartDate({ commit }, payload) {
    const apiResult = await apiService.post(route('member.project.get_project_start_date'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async confirmSimulation({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.confirm_simulation'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getTotalCo2AbsorptionData({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.simulation.get_total_co2_absorption_data'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
